module.exports = __webpack_public_path__ + "img/small-2.4b229ef8.jpg";